const classEn = {
    class: require('../../lang/en/class/Class').default,
};

export default classEn;
